// Module
var code = "<h2 id=\"doing-business-with-pheaa\">Doing Business with PHEAA</h2> <p>Follow the instructions to become a potential vendor if you&#39;re a supplier confident in delivering the service, quality, and competitive pricing PHEAA seeks.</p> ";
// Exports
export default code;